/**
 * LineageLens — Phase 1 full implementation.
 *
 * Layout (top → bottom):
 *   1. VersionTimeline — horizontal v1 → v2 → … → current node chain.
 *      Calls GET /briefs/{id}/version-chain.
 *   2. UpstreamProvenanceCard — source-type → source-detail tree.
 *      Reads brief.provenance + brief.metadata.
 *   3. DownstreamLineageTree — brief → ad packs → asset summary tree.
 *      Reads brief.playbook_ids; campaign details fetched on mount.
 */

import type { GenerationBrief } from '@/services/api';
import { VersionTimeline } from '../panels/VersionTimeline';
import { UpstreamProvenanceCard } from '../panels/UpstreamProvenanceCard';
import { DownstreamLineageTree } from '../panels/DownstreamLineageTree';

interface Props {
  brief: GenerationBrief;
}

export function LineageLens({ brief }: Props) {
  return (
    <div className="p-6 space-y-4">
      <VersionTimeline
        briefId={brief.brief_id}
        fallbackVersion={brief.version}
        fallbackStatus={brief.status}
      />
      <UpstreamProvenanceCard brief={brief} />
      <DownstreamLineageTree brief={brief} />
    </div>
  );
}
